export const MARQUEE_TYPE = {
  GENERAL: 0,
  DYNAMIC: 1,
};

export const MARQUEE_TABS = [
  { key: MARQUEE_TYPE.GENERAL, label: '一般跑馬燈' },
  { key: MARQUEE_TYPE.DYNAMIC, label: '動態跑馬燈' },
];

export const MARQUEE_STATE = {
  OFF: 0,
  ON: 1,
};

export const MARQUEE_STATE_OPTIONS = [
  { value: MARQUEE_STATE.ON, label: '啟用' },
  { value: MARQUEE_STATE.OFF, label: '禁用' },
];

export const MARQUEE_PAGE_SIZE = 20;
export const EN_LANG_CODE = 'en_US';

export function buildMarqueePageParams(pageNo, marqueeType, pageSize = MARQUEE_PAGE_SIZE) {
  return { pageNo, pageSize, marqueeType };
}

export function formatMarqueeState(state) {
  return state === MARQUEE_STATE.ON ? '啟用' : '禁用';
}

export function emptyMarqueeDetail(lang) {
  return {
    lang,
    title: '',
  };
}

export function mergeMarqueeDetailsWithLanguages(languages, existingDetails = []) {
  const langEntries = [];
  const seen = new Set();

  (languages || []).forEach((lang) => {
    const code = lang.code || lang;
    if (!code || seen.has(code)) {
      return;
    }
    seen.add(code);
    langEntries.push({
      code,
      label: lang.label || code,
    });
  });

  (existingDetails || []).forEach((item) => {
    if (!item?.lang || seen.has(item.lang)) {
      return;
    }
    seen.add(item.lang);
    langEntries.push({
      code: item.lang,
      label: item.lang,
    });
  });

  const map = new Map((existingDetails || []).map((item) => [item.lang, { ...item }]));
  return langEntries.map(({ code, label }) => {
    const found = map.get(code);
    return found
      ? { ...found, lang: code, _label: label }
      : { ...emptyMarqueeDetail(code), _label: label };
  });
}

export function stripMarqueeDetails(details) {
  return (details || []).map(({ lang, title }) => ({ lang, title: title || '' }));
}
